<script setup lang="ts">
import { locale, setLocale, t } from '../i18n'
</script>

<template>
  <div class="language-switcher" role="group" :aria-label="t('language.choose')">
    <button type="button" lang="de" :class="{ active: locale === 'de' }" :aria-pressed="locale === 'de'" aria-label="Deutsch" @click="setLocale('de')">DE</button>
    <span aria-hidden="true">·</span>
    <button type="button" lang="tr" :class="{ active: locale === 'tr' }" :aria-pressed="locale === 'tr'" aria-label="Türkçe" @click="setLocale('tr')">TR</button>
  </div>
</template>

<style scoped>
.language-switcher { position: fixed; top: max(14px, env(safe-area-inset-top)); right: max(14px, env(safe-area-inset-right)); z-index: 60; display: flex; align-items: center; gap: 7px; padding: 7px 9px; border: 1px solid rgba(168, 137, 79, .42); background: rgba(251, 247, 238, .9); color: var(--faded); box-shadow: 0 4px 18px rgba(58, 50, 38, .08); backdrop-filter: blur(8px); }
.language-switcher button { padding: 2px 3px; border: 0; background: transparent; color: inherit; font-size: 12px; font-weight: 600; letter-spacing: .13em; cursor: pointer; }
.language-switcher button.active { color: var(--ink); text-decoration: underline; text-decoration-color: var(--gold); text-underline-offset: 4px; }
.language-switcher button:focus-visible { outline: 2px solid var(--gold); outline-offset: 2px; }
.language-switcher span { color: #cdb98e; }
@media print { .language-switcher { display: none !important; } }
</style>
